import { Injectable } from '@angular/core';

import { LazyServiceProviderBase } from './lazy-service-provider-base';

/**
 * @stable
 */
@Injectable({
    providedIn: 'root',
})
export class GoogleAnalyticsCoreService extends LazyServiceProviderBase {
    track(event: any) {
        if (this.isReady) {
            this.inner.track(event);
        }
    }

    updateCookies() {
        if (this.isReady) {
            this.inner.updateCookies();
        }
    }
}
